<template>
	<card no-spacing flat :loading="props.checkpoint._loading" max-height="500">
		<card-title v-if="props.checkpoint.name">{{ props.checkpoint.name }}</card-title>

		<card-text
			v-if="props.checkpoint.description || props.checkpoint.full_address || (props.checkpoint.dates && props.checkpoint.dates.length)" class="overflow-y-auto" fill>
			<div v-if="props.checkpoint.description" class="whitespace-pre-wrap" v-html="props.checkpoint.description"/>

			<info-list small>
				<info-list-item v-if="props.checkpoint.full_address" :icon="icons.location" :text="props.checkpoint.full_address"/>
				<template v-if="props.checkpoint.dates && props.checkpoint.dates.length">
					<template v-for="(date, dateKey) in props.checkpoint.dates" :key="dateKey">
						<info-list-item v-if="date.start_date && date.end_date" :icon="icons.time"
										:text="t('label.time_window') + ' ' + (key + 1) + ': ' + $date(date.start_date).format('LLL') + ' - ' + $date(date.end_date).format('LLL')"/>
					</template>
				</template>
			</info-list>
		</card-text>

		<wrapper v-if="props.editable" class="px-16 py-16 lg:px-24 border-box border-t" stretch>
			<btn small @click="emit('move')" :title="t('action.move')">
				<Icon :icon="icons.move"/>
			</btn>
			<btn small color="success" @click="emit('edit')" :title="t('action.edit')">
				<Icon :icon="icons.edit"/>
			</btn>
			<btn small color="error" @click="emit('destroy')" :title="t('action.destroy')">
				<Icon :icon="icons.destroy"/>
			</btn>
		</wrapper>

	</card>
</template>

<script setup lang="ts">
import {mdiTimelineClockOutline} from "@mdi/js";
import {destroyIcon, editIcon, locationIcon, moveIcon} from "../../config";
import {useI18n} from '#imports';

const props = defineProps<{
	checkpoint: object,
	editable: boolean,
}>();
const emit = defineEmits(['move', 'edit', 'destroy']);

const {t, n} = useI18n();

const icons = {
	location: locationIcon,
	time: mdiTimelineClockOutline,
	edit: editIcon,
	move: moveIcon,
	destroy: destroyIcon
}
</script>